
import * as React from 'react';
import { AppBar, Toolbar } from '@mui/material';
import Container from '@mui/material/Container';
import blueLogo from 'assets/images/blueLogo.svg'


function PolicyHeader() {
  
  return (
    <AppBar position="static" className="bgColorBlue navAlign">
      <Container maxWidth="xl" className='h100'>
        <Toolbar disableGutters>
          <img src={blueLogo} alt='blueLogo' className='logoImage marginTop'/>  
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default PolicyHeader;